import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css/normalize.css"; // cssreset

import "./plugins/element/element.js";
import "./assets/iconfont/iconfont.css";
import "./assets/style/conmon.scss";
import Axios from "axios";
import serviceBaseUrl from "@/utils/baseurl";
import store from "./store";
Vue.prototype.GLOBAL = serviceBaseUrl;
// eslint-disable-next-line no-unused-vars
import $cookies from "vue-cookies";
Vue.use($cookies);
import * as filters from "./filters";
Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
// console.log(process.env.NODE_ENV);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
